//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

export enum DiagnosticErrorStatus {
  Success = 0x8400,
  Failed = 0x2400, // NOTE: 多個子項會 + 1
  NotComplete = 0x0001,
  NotSupported = 0x4800,
  Timeout = 0x2800,
  OutputError = 0x2801,
  FileNotFound = 0x2802,
  UnknownError = 0xffff,
  CommonPrivate = 0x4400,
}

export interface DiagnosticResultItemError {
  errCode: number;
  params?: string[];
  i18nDiagnosticKey: string;
}

export interface DiagnosticResultItem {
  name: string;
  errors: DiagnosticResultItemError[];
}

export interface ResponseDiagnosticResult {
  errCode: number;
  results: DiagnosticResultItem[];
}
